import React, { useContext } from 'react';
import { InstancesTable } from '../../../components/common';
import { UserContext } from '../../../contexts/user';

const CODIFIDashboard = () => {
    const { instances, isLoading } = useContext(UserContext);

    return (
        <div>
            <InstancesTable instances={instances()} isLoading={isLoading} />
        </div>
    );
};

export default CODIFIDashboard;
